import React from 'react';
import styles from './Checkout.module.scss';
import currency from 'currency.js';
import Button from '../../Button/v2';
import { Link } from 'react-router-dom';
import routes from '../../../routes';
import moment from 'moment';

export default function AppointmentSection({ cart }) {

  const orderPackages = cart.orderPackages.filter((orderPackage) => (
    !!orderPackage.appointmentTime
  ));

  return (
    <div className={styles.apptWrapper}>
      {orderPackages.map((orderPackage) => {
        const momentTime = moment(orderPackage.appointmentTime);
        const isDST = momentTime.isDST();
        const offset = isDST ? '-07:00' : '-08:00';
        const appointmentDate = orderPackage.appointmentTime.replace('+00:00', offset);
        const app_hour = parseInt(appointmentDate.split(" ")[1].split(":")[0])
        const AM_PM = app_hour >= 12 ? 'PM' : 'AM'
        console.log(orderPackage.schoolId);

        return (
          <div className={styles.apptContent}>
            <div>
              <div>
                <div className={styles.studentInfo}>
                  <p>{`${orderPackage.student.lastName}, ${orderPackage.student.firstName}`}</p>
                  <p>{`Grade: ${orderPackage.student.grade}`}</p>
                </div>
                <p>{`School: ${orderPackage.student.school.name}`}</p>
              </div>
              <div className={styles.apptOption}>
                <img src={orderPackage.apiOption.imageUrl} />
                <div className={styles.apptInfo}>
                  <p>{orderPackage.apiOption.name}</p>
                  <p>Date: <span>{appointmentDate.split(" ")[0].split("-")[1]}-{appointmentDate.split(" ")[0].split("-")[2]}-{appointmentDate.split(" ")[0].split("-")[0]}</span></p>
                  <p>Time: <span>{app_hour > 12 ? app_hour - 12 : app_hour}:{appointmentDate.split(" ")[1].split(":")[1]}{AM_PM}</span></p>
                  <p>Location: <span>{orderPackage.schoolId == 1075 ? 'Shoob Studio 4640 Spyres Way #1, Modesto, CA' : orderPackage.student.school.scheduleLocation}</span></p>
                </div>
              </div>
              <p className={styles.secureApptMsg}>Payment is required to secure your appointment time.</p>
              <div>
                <div className={styles.cartInfo}>
                  <p>Subtotal:</p>
                  <p>{currency(cart.subtotal).format()}</p>
                </div>
                <div className={styles.cartInfo}>
                  <p>Tax:</p>
                  <p>{currency(cart.apiTax).format()}</p>
                </div>
                <div className={styles.cartInfo}>
                  <p>Total:</p>
                  <p>{currency(cart.apiTotal).format()}</p>
                </div>
              </div>
            </div>
            <Link to={routes.scheduleAppointment({ senior: orderPackage.student.grade === '12' })}>
              <Button className={styles.addApptBtn} variant="">+ Add Another Appointment</Button>
            </Link>
            <div className={styles.apptPolicy}>
              <p>Appointment Policy:</p>
              <p>Please contact us at least 24 hours before your appointment time to reschedule.</p>
              <p>Session Fee includes time with the photographer. Portrait packages are sold separately.</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
